export const ClientContactGetters = {
  GetClientContact: 'getClientContact',
  GetClientContactAssignments: 'getClientContactAssignments',
  ClientContactAssignmentsSortOrder: 'clientContactAssignmentsSortOrder',
  GetClientContactValidationErrors: 'getClientContactValidationErrors'
};
export const ClientContactMutations = {
  SetClientContact: 'setClientContact',
  SetClientContactAssignments: 'setClientContactAssignments',
  SetClientContactAssignmentSortOrder: 'setClientContactAssignmentSortOrder',
  SetClientContactValidationErrors: 'setClientContactValidationErrors'
};
export const ClientContactActions = {
  GetClientContact: 'getClientContact',
  SaveClientContact: 'saveClientContact',
  GetClientContactAssignments: 'getClientContactAssignments',
  SetContractorAssignmentsSortOrder: 'setContractorAssignmentsSortOrder',
  UpdateClientContactValidationErrors: 'updateClientContactValidationErrors'
};
